import {
  Alert,
  Button,
  ModalDialog,
  Spinner,
  Typography,
} from "@ezmid/components-library";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";

import { useGetUserLessonsByUserIdAndCourseIdQuery } from "../../../api/users-lessons-course.generated";
import { makeRoute } from "../../../hooks/route";
import { AllRoutes } from "../../route/Route";

type Props = {
  onModalClose: () => void;
  isModalOpen: boolean;
  courseId?: string;
  userId?: string;
};

export function UserCourseLessonModal({
  onModalClose,
  courseId,
  userId,
  isModalOpen,
}: Props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { currentData, isFetching } = useGetUserLessonsByUserIdAndCourseIdQuery(
    {
      courseId: courseId || "",
      id: userId || "",
    },
    {
      skip: !courseId || !userId,
    }
  );

  return (
    <ModalDialog
      id="my-id"
      isOpen={isModalOpen}
      headerControls={
        <>
          <Typography variant="h5">{t("course.lessons.header")}</Typography>
          <button type="button">b</button>
        </>
      }
      title={t("course.lessons.header")}
      onRequestClose={onModalClose}
      footerControls={
        <Button variant="info" onClick={onModalClose}>
          {t("button.close")}
        </Button>
      }
    >
      {isFetching ? (
        <div className="w-full flex justify-center h-full min-h-full max-h-fit  px-2 py-1">
          <Spinner isLoading type="fadeLoader" size="20" color="#38bdf8" />
        </div>
      ) : (
        <ul className="flex">
          {currentData?.items?.length ? (
            currentData?.items?.map(({ lesson }) => {
              const langCode = i18n.language.split("-")[0];
              const translatedName = lesson?.translations?.find(
                (translation) => translation?.language === langCode
              )?.name;
              const translatedDescription = lesson?.translations?.find(
                (translation) => translation?.language === langCode
              )?.text;
              const lessonImgUrl = lesson?.titleImage?.image?.content?.find(
                ({ type }) => type === "square-small"
              )?.url;

              return (
                <li
                  key={lesson?.id || ""}
                  className="w-full max-w-sm bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 m-2"
                >
                  <div className="flex content-center justify-center p-2">
                    <img
                      src={lessonImgUrl}
                      alt="lesson"
                      className="rounded object-cover"
                    />
                  </div>
                  <div className="px-2 pb-2">
                    <div className="flex flex-col justify-between leading-normal">
                      <Typography variant="h5" className=" text-white">
                        {translatedDescription}
                      </Typography>
                      <Typography variant="h6" className=" text-white">
                        {translatedName}
                      </Typography>
                    </div>
                    <div className="py-2">
                      <Button
                        type="button"
                        onClick={() => {
                          navigate(
                            makeRoute(AllRoutes.LESSON_DETAIL, {
                              id: lesson?.id,
                            })
                          );
                        }}
                      >
                        {t("button.show")}
                      </Button>
                    </div>
                  </div>
                </li>
              );
            })
          ) : (
            <Alert variant="error">{t("course.lessons.modal.no.lesson")}</Alert>
          )}
        </ul>
      )}
    </ModalDialog>
  );
}
